import { IconX } from '@tabler/icons-react';
import React, { useState } from 'react'
import { Modal } from 'react-bootstrap';

const ChooseBuildElementModal = ({ selectItemFunction }) => {
    const [show, setShow] = useState(false);

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    const select = (item) => {
        if (selectItemFunction) {
            selectItemFunction(item);
        }
        handleClose();
    }

    return (
        <div className='flex items-center'>
            <button className="font-semibold text-sm text-white bg-primary !px-5 !py-2 rounded-full" onClick={handleShow}>
                Add New
            </button>
            <Modal show={show} onHide={handleClose} >
                <Modal.Body className=' rounded-xl'>
                    <div className="flex justify-between items-center">
                        <p className="text-md font-semibold mb-0">Add To Your Page</p>
                        <IconX className='cursor-pointer' onClick={handleClose} />
                    </div>
                    <hr className='my-3' />

                    <p className='font-semibold text-lg'>Content</p>
                    <div className="flex items-center gap-3 mb-3">
                        <img src={process.env.PUBLIC_URL + "/images/blocks/link.png"} alt="" />
                        <div>
                            <p className='mb-0 font-bold text-md'>Link</p>
                            <p className="mb-0 text-xs text-[#B5B5C3] font-medium">Add a link button</p>
                        </div>
                        <button className='ms-auto font-semibold text-sm text-white bg-primary px-3 py-1.5 rounded-full' onClick={() => select('link')}>Add</button>
                    </div>
                    <div className="flex items-center gap-3 mb-3">
                        <img src={process.env.PUBLIC_URL + "/images/blocks/image.png"} alt="" />
                        <div>
                            <p className='mb-0 font-bold text-md'>Image</p>
                            <p className="mb-0 text-xs text-[#B5B5C3] font-medium">Place an Image</p>
                        </div>
                        <button className='ms-auto font-semibold text-sm text-white bg-primary px-3 py-1.5 rounded-full' onClick={() => select('image')}>Add</button>
                    </div>
                    <div className="flex items-center gap-3 mb-3">
                        <img src={process.env.PUBLIC_URL + "/images/blocks/youtube.png"} alt="" />
                        <div>
                            <p className='mb-0 font-bold text-md'>Youtube</p>
                            <p className="mb-0 text-xs text-[#B5B5C3] font-medium">Add a youtube link</p>
                        </div>
                        <button className='ms-auto font-semibold text-sm text-white bg-primary px-3 py-1.5 rounded-full' onClick={() => select('youtube')}>Add</button>
                    </div>
                    <p className='font-semibold text-lg'>Layout</p>
                    <div className="flex items-center gap-3 mb-3">
                        <img src={process.env.PUBLIC_URL + "/images/blocks/carousel.png"} alt="" />
                        <div>
                            <p className='mb-0 font-bold text-md'>Carousel</p>
                            <p className="mb-0 text-xs text-[#B5B5C3] font-medium">Add Image Slider</p>
                        </div>
                        <button className='ms-auto font-semibold text-sm text-white bg-primary px-3 py-1.5 rounded-full' onClick={() => select('carousel')}>Add</button>
                    </div>
                    <div className="flex items-center gap-3 mb-3">
                        <img src={process.env.PUBLIC_URL + "/images/blocks/grid.png"} alt="" />
                        <div>
                            <p className='mb-0 font-bold text-md'>Grid</p>
                            <p className="mb-0 text-xs text-[#B5B5C3] font-medium">Add total of 9 image for 3 columns</p>
                        </div>
                        <button className='ms-auto font-semibold text-sm text-white bg-primary px-3 py-1.5 rounded-full' onClick={() => select('grid')}>Add</button>
                    </div>
                </Modal.Body>
            </Modal>
        </div>
    )
}

export default ChooseBuildElementModal